import router from '@/router'
import AccessTokenHelper from 'helpers/AccessTokenHelper'
import LocalStorage from 'helpers/browserStorage/LocalStorage'
import httpClient from 'httpClient'
export default function interceptorSetup () {
  httpClient.interceptResponse(response => response,
    async (error) => {
      const originalRequest = error.config
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true
        await AccessTokenHelper.getAccessTokenFromIS()
        const accessToken = LocalStorage.get('accessToken')
        originalRequest.headers['Authorization'] = 'Bearer ' + accessToken
        return httpClient.request(originalRequest)
      } else {
        router.push('/503')
      }
    })
}



// WEBPACK FOOTER //
// ./src/helpers/interceptor.js